export default __webpack_public_path__ + "static/media/menu.0c8d2d60.svg";